module.exports = __webpack_public_path__ + "static/media/noData.ec715519.jpg";